import { AxiosResponse } from 'axios';

import { IEmployee } from '@entities/employee/model/types';
import { $api } from '@shared/api';
import { handleAxiosFetchErrorsSwal } from '@shared/helpers/fetchHelpers';

interface IAddEmployee {
    role: IEmployee['position'];
    email: IEmployee['email'];
}

export const addToExistEstimate = async ({
    role,
    email,
}: IAddEmployee): Promise<AxiosResponse<{ success: boolean }> | undefined> => {
    // @ts-ignore
    const url = helpable.replaceUrlParameters(routable.getRoute('addEmployeeToExistEstimates'), {
        _email_: email,
    });
    const formData = new FormData();
    formData.append('role', role);

    try {
        return await $api.post<{ success: boolean }>(url, formData);
    } catch (error) {
        handleAxiosFetchErrorsSwal(error);
        return error.message;
    }
};
